import clsx from 'clsx'
import { Icon } from '@iconify/react'
import { useModal } from '@ebay/nice-modal-react'
import { Button, DomainSelector, Spin, useMessage } from '@pepper/ui'
import { ContentRefreshDomain } from '@pepper/utils/src/types/domain'

import GoogleIntegrationButton from 'components/GoogleIntegrationButton'
import { useSelectedCompanyId } from 'utils/functions/misc'

import s from './CmpStatsDefault.module.css'

type Props = {
  domains: ContentRefreshDomain[]
  isLoadingDomains: boolean
  onAddDomain: () => void
  width: 'full' | 'half'
}

export const CmpStatsDefault = ({
  domains,
  isLoadingDomains,
  onAddDomain,
  width,
}: Props) => {
  const companyId = useSelectedCompanyId()
  const { showError } = useMessage()
  const { show: showAddDomainModal } = useModal('add-domain')

  if (isLoadingDomains) {
    return (
      <div className={clsx(s.container, s[width])}>
        <Spin />
      </div>
    )
  }

  return (
    <div className={clsx(s.container, s[width])}>
      <div className={s.content}>
        {width === 'full' && (
          <p className={s.helpText}>
            <Icon icon="lucide:lock" />
            Unlock Features
          </p>
        )}

        {domains.length > 0 ? (
          <>
            <h2 className={s.title}>
              {width === 'full'
                ? 'Connect your Analytics and Search Console to unlock all the features'
                : 'Connect your Analytics and Search Console'}
            </h2>
            <div className={s.domain}>
              <DomainSelector companyId={companyId} isControlled={false} />
              <GoogleIntegrationButton
                companyId={companyId}
                onError={showError}
                cta="Connect Google account"
              />
            </div>
          </>
        ) : (
          <>
            <h2 className={s.title}>Get started by setting up your domain</h2>
            <Button
              type="primary"
              icon={<Icon icon="lucide:arrow-right" />}
              iconPlacement="right"
              onClick={() => showAddDomainModal({ refetch: onAddDomain })}
              data-id="no-domain-enter-domain-button"
            >
              Enter Domain
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
